import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
import "@/assets/js/Chart.roundedBarCharts.min.js"

import "@/assets/js/Chart.roundedBarCharts.min.js"
export default {
  extends: Bar,
  mixins: [reactiveProp],

  props: ["options"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
